import { render } from "./slide3.vue?vue&type=template&id=2259d330&scoped=true"
import script from "./slide3.vue?vue&type=script&lang=js"
export * from "./slide3.vue?vue&type=script&lang=js"

import "./slide3.vue?vue&type=style&index=0&id=2259d330&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2259d330"]])

export default __exports__